export const characters = [
  {
    id: 'yadang',
    name: '亚当君',
    title: '挣扎者',
    description: '本作主角，一个在命运夹缝中挣扎的普通青年。外表温和内心敏感，面对突如其来的命运转折，他必须在恐惧与勇气之间做出抉择。他的每一个选择，都将影响整个世界的走向。',
    traits: ['内心敏感', '善于观察', '正义感强', '缺乏自信'],
    image: 'https://readdy.ai/api/search-image?query=A%20young%20man%20character%20portrait%20in%20warm%20golden%20and%20crimson%20lighting%2C%20Chinese%20anime%20art%20style%2C%20emotional%20expression%2C%20dramatic%20atmosphere%2C%20soft%20background%20with%20ink%20wash%20texture%2C%20clean%20simple%20composition&width=600&height=800&seq=char-yadang-01&orientation=portrait'
  },
  {
    id: 'lilisi',
    name: '莉莉丝',
    title: '引导者',
    description: '神秘的女性角色，似乎对亚当君的命运了如指掌。优雅而疏离，她的每一句话都暗藏玄机。是盟友还是操纵者？真相等待玩家揭晓。',
    traits: ['神秘莫测', '智慧超群', '优雅从容', '若即若离'],
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20elegant%20female%20character%20portrait%2C%20warm%20golden%20lighting%2C%20Chinese%20anime%20art%20style%2C%20enigmatic%20expression%2C%20flowing%20hair%2C%20dramatic%20atmosphere%2C%20soft%20ink%20wash%20background%2C%20clean%20composition&width=600&height=800&seq=char-lilisi-01&orientation=portrait'
  },
  {
    id: 'luka',
    name: '路卡',
    title: '同行者',
    description: '亚当君在旅途中结识的伙伴，性格开朗直率，是照亮黑暗旅程的一束光。然而，在他爽朗笑容的背后，也隐藏着不为人知的伤痛。',
    traits: ['开朗直率', '忠诚可靠', '幽默风趣', '隐藏伤痛'],
    image: 'https://readdy.ai/api/search-image?query=A%20cheerful%20young%20male%20character%20portrait%2C%20warm%20golden%20lighting%2C%20Chinese%20anime%20art%20style%2C%20bright%20expression%20with%20hidden%20depth%2C%20casual%20outfit%2C%20soft%20ink%20wash%20background%2C%20clean%20composition&width=600&height=800&seq=char-luka-01&orientation=portrait'
  },
  {
    id: 'mingyun',
    name: '命运之影',
    title: '反派',
    description: '游走于世界夹层中的神秘存在，是一切混乱的源头。没有固定形态，却无处不在。它的目的究竟是什么？',
    traits: ['无形无相', '无所不在', '深不可测', '操控命运'],
    image: 'https://readdy.ai/api/search-image?query=A%20shadowy%20mysterious%20figure%20character%20concept%2C%20dark%20crimson%20and%20gold%20accents%2C%20Chinese%20ink%20painting%20style%2C%20ethereal%20and%20threatening%20presence%2C%20dramatic%20atmosphere%2C%20clean%20minimal%20background&width=600&height=800&seq=char-mingyun-01&orientation=portrait'
  }
];

export const storyChapters = [
  {
    chapter: '第一章',
    title: '觉醒',
    description: '一个看似平常的早晨，一封神秘信件的到来，彻底改变了亚当君的人生轨迹。当日常的帷幕被撕开，隐藏在世界背后的真相开始浮现。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20mysterious%20letter%20arriving%20on%20a%20quiet%20morning%2C%20warm%20golden%20light%2C%20Chinese%20ink%20painting%20style%2C%20atmospheric%20and%20emotional%2C%20clean%20composition&width=800&height=500&seq=story-ch1-01&orientation=landscape'
  },
  {
    chapter: '第二章',
    title: '十字路口',
    description: '面对命运的第一次重大考验，亚当君站在了人生的十字路口。每一个方向都通往不同的未来，而选择的代价远超想象。',
    image: 'https://readdy.ai/api/search-image?query=A%20crossroads%20scene%20in%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20multiple%20paths%20extending%20into%20mist%2C%20Chinese%20artistic%20style%2C%20emotional%20and%20atmospheric%2C%20clean%20composition&width=800&height=500&seq=story-ch2-01&orientation=landscape'
  },
  {
    chapter: '第三章',
    title: '深渊回响',
    description: '当亚当君深入世界的夹层，隐藏在表象之下的真相令人窒息。那些被遗忘的记忆和被掩盖的历史，一一浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=A%20deep%20abyss%20scene%20with%20shimmering%20golden%20light%20from%20above%2C%20dark%20crimson%20undertones%2C%20Chinese%20ink%20wash%20style%2C%20mysterious%20and%20atmospheric%2C%20clean%20composition&width=800&height=500&seq=story-ch3-01&orientation=landscape'
  },
  {
    chapter: '第四章',
    title: '黎明的选择',
    description: '一切线索汇聚于终点。当命运的天平悬于一线，亚当君必须做出最终的抉择——是接受命运的安排，还是亲手改写一切？',
    image: 'https://readdy.ai/api/search-image?query=A%20dawn%20breaking%20scene%20with%20warm%20golden%20light%20piercing%20through%20darkness%2C%20dramatic%20contrast%2C%20Chinese%20ink%20painting%20style%2C%20hopeful%20and%20emotional%2C%20clean%20composition&width=800&height=500&seq=story-ch4-01&orientation=landscape'
  }
];